import { api, SKIP_AUTO_CONTENT_TYPE_HEADER } from './api';

// Define Export Configuration service
export const ioConfigurationApi = api.injectEndpoints({
  reducerPath: 'ioConfigurationApi',
  tagTypes: ['ExportConfiguration'],
  endpoints: (builder) => ({
    exportConfiguration: builder.mutation({
      query: (exportRequest) => ({
        url: `/api/administration/configuration/export`,
        method: 'POST',
        body: exportRequest,
        responseHandler: async (response) => {
          if (!response.ok) {
            throw new Error(`Export failed: ${response.statusText}`);
          }
          return response.blob();
        }
      }),
      transformResponse: (blob, meta) => {
        // Extract filename from Content-Disposition header
        const contentDisposition = meta.response.headers.get('Content-Disposition');
        let filename = 'config_export.zip';

        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
          }
        }

        return { blob, filename };
      }
    }),
    analyzeImport: builder.mutation({
      query: (formData) => ({
        url: `/api/administration/configuration/analyze`,
        method: 'POST',
        body: formData,
        headers: {
          [SKIP_AUTO_CONTENT_TYPE_HEADER]: 'true'
        }
      })
    }),
    importConfiguration: builder.mutation({
      query: ({ uuid, importMode, importRequest }) => ({
        url: `/api/administration/configuration/import/${uuid}?importMode=${importMode}`,
        method: 'POST',
        body: importRequest
      })
    })
  })
});

// Export hooks for usage in functional components
export const {
  useExportConfigurationMutation,
  useAnalyzeImportMutation,
  useImportConfigurationMutation
} = ioConfigurationApi;
